import * as React from 'react';

function SvgFilesAlt(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M11 0H3a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2 2 2 0 002-2V4a2 2 0 00-2-2 2 2 0 00-2-2zm2 3a1 1 0 011 1v8a1 1 0 01-1 1V3zM2 2a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V2z' />
		</svg>
	);
}

export default SvgFilesAlt;
